var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.46,5 C17.4,5.89 17.25,6.76 17.01,7.59 L18.21,8.79 C18.62,7.59 18.88,6.32 18.97,5 L17.46,5 L17.46,5 Z M7.6,17.02 C6.75,17.26 5.88,17.41 5,17.47 L5,18.96 C6.32,18.87 7.59,18.61 8.8,18.21 L7.6,17.02 Z M16.5,3 L20,3 C20.55,3 21,3.45 21,4 C21,13.39 13.39,21 4,21 C3.45,21 3,20.55 3,20 L3,16.51 C3,15.96 3.45,15.51 4,15.51 C5.24,15.51 6.45,15.31 7.57,14.94 C7.67,14.9 7.78,14.89 7.88,14.89 C8.14,14.89 8.39,14.99 8.59,15.18 L10.79,17.38 C13.62,15.93 15.94,13.62 17.38,10.79 L15.18,8.59 C14.9,8.31 14.82,7.92 14.93,7.57 C15.3,6.45 15.5,5.25 15.5,4 C15.5,3.45 15.95,3 16.5,3 Z",
    id: "Shape",
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.55da0e702450d34108fe77f8b37b90f9.svg";
export { ForwardRef as ReactComponent };